import React, { useState, useEffect } from 'react'
import styles from '../style/pages/purchasedPage.module.css'
import VideoList from 'components/VideoList'
import axios from 'axios'


const PurchasedProduct = () => {
	const [videos, setVideos] = useState([])
  const [user, setUser] = useState({})

	useEffect(() => {
		const getVideos = async () => {
			try {
				const res = await axios.get("https://rishat-tour.ru/api/purchase", {
					headers: {
						Authorization: `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
					}
				})
				setVideos(res.data)
			} catch (error) {
				console.log(error.message)
			}
		}
		getVideos()
	}, [])


		useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"))
    if (token) {
      setUser(token.userObj)
    }

  }, [])

	const date = new Date(user.createdAt);

	const formattedDate = date.toLocaleDateString("ru-RU", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric"
	});

	if (!videos || videos.length === 0) {
		return (
			<div class={styles.purchasedWrapper}>
				<p>У вас нет приобретенных товаров!</p>
			</div>
		)
	}

	return (
		<div className={styles.container}>
			<div className={styles.wrapperPurch}>
				<div className={styles.purchasedTitle}>
					<h2>Приобретенные видео</h2>
				</div>
				<div className={styles.purchasedName}>
					<p>{user.lastName[0].toUpperCase() + user.lastName.slice(1).toLowerCase()} {user.firstName.slice(0, 1).toUpperCase()}. {formattedDate}</p>
				</div>
				
					{
						<VideoList videos={videos} isBougth={true} />
					}
				
			</div>
		</div>
	)
}
export default PurchasedProduct
